






























































































import Vue, { PropType } from 'vue';
import {
  Configuration,
  ConfigurationItem
} from '@/models/configurator/configuration';
import { mapActions } from 'vuex';
import { IItem } from '@/models';

import { scrollToBottomOfHtmlElement } from '@/utils/helpers';
import AfterPartsItemImportDialog from './spareparts/AfterPartsItemImportDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';

export default Vue.extend({
  components: { AfterPartsItemImportDialog, ErrorAlert },
  name: 'ItemBuilderCard',
  props: {
    configuration: {
      type: Object as PropType<Configuration>
    },

    snapshot: {
      type: Number as PropType<number>
    },

    exchangeRate: Number,
    currencyCode: String
  },

  data: () => ({
    search: '',
    configurationItems: [] as ConfigurationItem[],
    isLoading: false,

    errorMessage: '',
    detailErrorMessage: ''
  }),

  methods: {
    ...mapActions({
      createConfigurationItem:
        'configuratorConfiguration/createConfigurationItem',

      fetchConfigurationItems:
        'configuratorConfiguration/fetchConfigurationItems',

      deleteConfigurationItem:
        'configuratorConfiguration/deleteConfigurationItem'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    getConfigurationItems() {
      return this.fetchConfigurationItems(this.configuration.id);
    },

    async refreshListAfterUpload() {
      this.clearAllErrors();
      await this.refreshConfigurationList();
      await scrollToBottomOfHtmlElement(
        '#scrollableItemsCard.v-data-table--fixed-header>.v-data-table__wrapper'
      );
    },

    refreshConfigurationList() {
      return this.getConfigurationItems().then(itemList => {
        this.configurationItems = itemList;
      });
    },

    async destroyConfigurationItem(item: ConfigurationItem) {
      const confirm = (this as any).$refs.confirm;

      if (
        await confirm.open(
          'Delete Item',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${item.item}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        this.deleteConfigurationItem(item).then(() => {
          this.refreshConfigurationList();
        });
      }
      return;
    },

    async addConfigurationItem(item: IItem) {
      this.clearAllErrors();
      // parse to configurable item
      if (item) {
        // TODO: LF-2021-02-10 - Need to explore using multiple
        // constructors in TypeScript
        const parsedConfigItem = new ConfigurationItem();
        // should be done from constructor
        parsedConfigItem.item = item.item;
        parsedConfigItem.quantity = 1;
        parsedConfigItem.unit = item.unit;
        parsedConfigItem.configuration = this.configuration.id;
        parsedConfigItem.unit_price = Number(item.price);
        parsedConfigItem.is_machine = item.is_machine;
        parsedConfigItem.invalid_item = item.invalid_item;
        parsedConfigItem.is_obsolete = item.is_obsolete;

        // order for item to be appended to end of list
        parsedConfigItem.order = this.configurationItems.length + 1;

        await this.createConfigurationItem(parsedConfigItem)
          .then(() => {
            this.refreshConfigurationList();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          });
      }

      await scrollToBottomOfHtmlElement(
        '#scrollableItemsCard.v-data-table--fixed-header>.v-data-table__wrapper'
      );

      this.search = '';
    },

    save() {
      this.$emit('save');
    },

    openAfterPartsImportDialog() {
      const afterPartsDialog = this.$refs
        .afterPartsImportDialog as InstanceType<
        typeof AfterPartsItemImportDialog
      >;

      afterPartsDialog.open(this.configuration.id!);
    }
  }
});
